// extracted by mini-css-extract-plugin
module.exports = {"page":"DiagnosticsScreen_page__2sfo-"};